const checkInInitialState = {
  outstanding: {},
  activeGoals: [],
};

export default checkInInitialState;
